<template>
  <div class="border border-gray-border rounded-md p-8">
    <div class="flex justify-between">
      <div>
        <img class="w-36" src="/logo.png" alt="" />
        <div class="mt-4 text-lg font-extrabold text-gray-900">
          {{ invoiceData.external_id }}
        </div>
      </div>
      <div class="text-right">
        <div class="text-gray-600">
          Tanggal Terbit:
          {{
            moment(invoiceData.createdAt).locale("id").format("DD MMMM YYYY")
          }}
        </div>
        <div class="text-gray-600 mt-1">
          Status: {{ invoiceData.status === "success" ? "Terbayar" : "-" }}
        </div>
      </div>
    </div>
    <div class="my-6 border-b border-gray-border"></div>
    <div class="flex justify-between">
      <div class="flex flex-col space-y-1 text-left">
        <div class="text-primary">Tagihan Dari:</div>
        <!-- <div class="text-gray-900 font-bold">Tholhah TV</div>
        <div>tholhahtv@gmail.com</div>
        <div>0897312731281</div>
        <div>www.tholhah.tv</div> -->
        <div class="text-gray-900 font-bold">Livesteer</div>
        <div>tholhahtv@gmail.com</div>
        <div>0897312731281</div>
        <div>www.livesteer.com</div>
      </div>
      <div class="flex flex-col space-y-1 text-right">
        <div class="text-primary">Tagihan Untuk:</div>
        <div class="text-gray-900 font-bold">
          {{ invoiceData.customerId.firstName }}
          {{
            invoiceData.customerId.lastName
              ? invoiceData.customerId.lastName
              : ""
          }}
        </div>
        <div>{{ invoiceData.customerId.email }}</div>
        <div>{{ invoiceData.customerId.phoneNumber }}</div>
        <!-- <div>www.tholhah.tv</div> -->
      </div>
    </div>
    <div class="my-6"></div>
    <div class="overflow-hidden border border-gray-border rounded-md">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th
              width="50%"
              scope="col"
              class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              Course
            </th>
            <th
              scope="col"
              class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              Qty
            </th>
            <th
              scope="col"
              class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              Harga
            </th>
          </tr>
        </thead>
        <tfoot class="bg-gray-50">
          <tr>
            <th
              colspan="2"
              class="px-5 py-3 text-right text-xs text-gray-500 font-medium uppercase tracking-wider"
            >
              Total:
            </th>
            <td class="px-5 py-3 text-right text-md text-gray-900 font-bold">
              {{ thousandPrice(invoiceData.totalPrice) }}
            </td>
          </tr>
        </tfoot>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr v-for="item in invoiceData.transactionDetails" :key="item._id">
            <td width="50%" class="px-6 py-4">
              <div class="text-sm font-medium text-gray-900">
                {{ item.courseName }}
              </div>
            </td>
            <td class="px-6 py-4">
              <div class="text-sm text-center text-gray-500">1</div>
            </td>
            <td class="px-6 py-4">
              <div class="text-sm text-right text-gray-500">
                {{ thousandPrice(item.coursePrice) }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import thousandPrice from '@/helpers/thousandPrice'
export default {
  props: {
    invoiceData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      thousandPrice,
      moment,
    }
  },
}
</script>

<style>
</style>
